import type { FC } from 'react';
import { Container } from '@/DesignSystem/Component';
import SubscriptionCarts from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageNew/SubscriptionCarts';
import SubscriptionPageFree from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageNew/SubscriptionPageFree';
import { useSubscriptionPlans } from '@/Module/Subscription/Hooks';
const SubscriptionPageCore: FC = () => {
  const {
    lightPlans,
    proPlans
  } = useSubscriptionPlans();
  return <Container className=" mb-10" data-sentry-element="Container" data-sentry-component="SubscriptionPageCore" data-sentry-source-file="SubscriptionPageCore.tsx">
      <div className="mx-auto max-w-[840px] text-center" id="subscription">
        <h1 className="mb-4 mt-8 text-2xl font-bold text-blackFive sm:text-3xl md:mt-12">خرید اشتراک آی‌نو</h1>
        <p className="mb-4 text-base text-blackThree md:mb-8 md:text-xl ">یادگیری آنلاین برای همه آسان و مقرون‌به‌صرفه!</p>
      </div>
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-6 md:grid-cols-3 md:gap-2 lg:gap-6">
        <SubscriptionPageFree data-sentry-element="SubscriptionPageFree" data-sentry-source-file="SubscriptionPageCore.tsx" />
        <SubscriptionCarts data={lightPlans} data-sentry-element="SubscriptionCarts" data-sentry-source-file="SubscriptionPageCore.tsx" />
        <SubscriptionCarts data={proPlans} data-sentry-element="SubscriptionCarts" data-sentry-source-file="SubscriptionPageCore.tsx" />
      </div>
    </Container>;
};
export default SubscriptionPageCore;